module.exports = "<nav id=\"sidebar\">\n  <ul class=\"nav flex-column\">\n    <ng-content></ng-content>\n  </ul>\n</nav>"